<div class="drw-container">
  <div class="drw-header">
    <span class="drw-title">Refund Capture</span>
    <button (click)="close()" mat-icon-button [disabled]="isSubmitting || isLoading">
      <mat-icon class="drw-close" viewBox="0 0 24 24" fill="none">close</mat-icon>
    </button>
  </div>

  <!-- Loading state -->
  @if (isLoading) {
    <div class="drw-content loading-state">
      <mat-spinner [diameter]="32"></mat-spinner>
      <p>Loading capture information...</p>
    </div>
  } @else {
    <div class="drw-content">
      <div class="drw-sub-content">
        <span class="drw-title">Capture Information</span>
        <div class="authorization-info">
          <p>Transation ID: <span>{{ data.transactionevent.id }}</span></p>
          <p>Captured Amount: <span>{{ data.transactionevent.amount | currency }}</span></p>
          <p>Remaining Amount: <span>{{ data.transactionevent.remaining_amount | currency }}</span></p>
        </div>
      </div>
      <div class="drw-sub-content">
        <span class="drw-title">Refund Information</span>
        <form [formGroup]="refundForm" class="refund-form">
          <!-- Transaction Amount -->
          <label for="amount">Transaction Amount</label>
          <mat-form-field appearance="fill" class="full-width">
            <span matPrefix>&nbsp;$</span>
            <input
              matInput
              formControlName="amount"
              id="amount"
              placeholder="Amount"
              type="text"
              mask="separator.2"
              [thousandSeparator]="','"
              />
              @if (refundForm.get('amount')?.hasError('required')) {
                <mat-error>
                  Transaction amount is required
                </mat-error>
              }
              @if (refundForm.get('amount')?.hasError('min')) {
                <mat-error>
                  Amount must be at least $0.01
                </mat-error>
              }
              @if (refundForm.get('amount')?.hasError('max')) {
                <mat-error>
                  Amount cannot exceed captured amount of
                  {{ data.transactionevent.remaining_amount | currency }}
                </mat-error>
              }
              @if (refundForm.get('amount')?.hasError('pattern')) {
                <mat-error>
                  Please enter a valid amount (up to 2 decimal places)
                </mat-error>
              }
            </mat-form-field>
            <!-- Memo -->
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Memo</mat-label>
              <textarea
                matInput
                formControlName="memo"
                placeholder="Optional memo"
                rows="3"
              ></textarea>
            </mat-form-field>
          </form>
        </div>
      </div>
      <div class="drw-footer">
        <button
          class="dialog-submit"
          mat-flat-button
          color="accent"
          [disabled]="refundForm.invalid || isSubmitting || isLoading"
          (click)="submit()"
          >
          @if (isSubmitting) {
            <mat-spinner [diameter]="20" color="accent"></mat-spinner>
          }
          @if (!isSubmitting) {
            <span>Refund Capture</span>
          }
        </button>
      </div>
    }

    <!-- Loaded state -->
  </div>
